<template lang="pug">
  div(:class="{'text-center': alignCenter}", data-testid="top-message")
    .alert.alert-warning(v-if="errorMessages.length > 0 || errorTitleMessage.length > 0", data-testid="-warning-message")
      h4(v-if="errorTitleMessage")
        i(v-if="errorIconClass" :class="errorIconClass")
        | {{errorTitleMessage}}
      p(v-for="message in errorMessages") {{message}}

    .alert.alert-success(v-if="successMessages.length > 0 || successTitleMessage.length > 0", data-testid="-success-message")
      h4(v-if="successTitleMessage")
        i(v-if="successIconClass" :class="successIconClass")
        | {{successTitleMessage}}
      p(v-for="message in successMessages") {{message}}

    .alert.alert-info(v-if="infoMessages.length > 0 || infoTitleMessage.length > 0")
      h4(v-if="infoTitleMessage")
        i(v-if="infoIconClass" :class="infoIconClass")
        | {{infoTitleMessage}}
      p(v-for="message in infoMessages") {{message}}

    .alert.alert-default(v-if="defaultMessages.length > 0")
      p(v-for="message in defaultMessages") {{message}}
</template>

<script>
export default {
  name: 'AppMessages',
  props: {
    alignCenter: {type: Boolean, required: false, default: false},
    errorMessages: {type: Array, default: function () { return [] }},
    errorIconClass: {type: String, default: 'icon fa fa-warning'},
    errorTitleMessage: {type: String, default: ''},
    successMessages: {type: Array, default: function () { return [] }},
    successIconClass: {type: String, default: 'icon fa fa-info-circle'},
    successTitleMessage: {type: String, default: ''},
    infoMessages: {type: Array, default: function () { return [] }},
    infoIconClass: {type: String, default: 'icon fa fa-info-circle'},
    infoTitleMessage: {type: String, default: ''},
    defaultMessages: {type: Array, default: function () { return [] }}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/AppMessages.vue